/**
 * BrewNectar Side-by-Side — scroll fade-up + smooth anchor CTA (Manus #offers)
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initSection(section) {
    if (!section || section.dataset.bnSbsInit === 'true') return;
    section.dataset.bnSbsInit = 'true';

    var animated = section.querySelectorAll('.bn-sbs__animate');
    var ctaLinks = section.querySelectorAll('[data-bn-sbs-cta]');

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
    } else {
      var rootMargin = section.getAttribute('data-bn-sbs-observer-margin') || '-60px 0px';

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { root: null, rootMargin: rootMargin, threshold: 0 }
      );

      animated.forEach(function (el) {
        observer.observe(el);
      });
    }

    ctaLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;

        var target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();
        if (window.BrewNectarScroll) {
          window.BrewNectarScroll.scrollToElement(target);
        } else {
          target.scrollIntoView({
            behavior: prefersReducedMotion() ? 'auto' : 'smooth',
            block: 'start'
          });
        }
        history.replaceState(null, '', href);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bn-sbs-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-bn-sbs-section]') || e.target;
    if (section.matches && section.matches('[data-bn-sbs-section]')) {
      section.dataset.bnSbsInit = '';
      initSection(section);
    }
  });
})();
